<template>
  <v-container>
    <v-layout row>
      <!-- OBJECT TITLE -->
      <home-item-title>
        {{ $t("home.last-size") }}
      </home-item-title>
    </v-layout>
    <!-- ITEM LIST -->
    <v-layout
      v-for="(size, index) in sizes"
      :key="index"
      class="pb-2"
      row
      @click="dimensionSelected(size)"
    >
      <!-- ITEM -->
      <dimensions-list-item
        :link="size.link"
        @click="dimensionSelected(size)"
      >
        {{ size.width }} x {{ size.height }} px
      </dimensions-list-item>
    </v-layout>
  </v-container>
</template>

<script>
// Components
import homeItemTitle from "./HomeItemTitle";
import dimensionsListItem from "./DimensionsListItem";

// Connectors
import { ProfileFavouriteConnector } from "../Database/ProfileFavouriteConnector.js";

export default {
  components: {
    homeItemTitle,
    dimensionsListItem,
  },
  data() {
    return {
      favConnector: new ProfileFavouriteConnector(this.$store.state.user),
      sizes: [],
    };
  },
  created() {
    if (this.$store.state.user.socId != null) {
      this.getHistDimensions();
    }
  },
  methods: {
    getHistDimensions() {
      this.favConnector
        .getHistDimensions(6)
        .then((dimensions) => {
          // TODO: format in db server
          this.sizes = dimensions.map((data) => {
            return {
              width: data.width,
              height: data.height,
              link: "/home",
            };
          });
        })
        .catch((err) => {
          console.error(err);
        });
    },
    dimensionSelected(size) {
      this.favConnector
        .insertHistDimension(size.width, size.height)
        .then(() => {
          this.$emit("dimensionSelected", this.$t("project.blank-title"), {
            x: 0,
            y: 0,
            width: size.width,
            height: size.height,
            scale: {
              x: 1,
              y: 1,
            },
          });
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
};
</script>

<style>
.icon-text-offset {
  display: inline-block;

  position: relative;
  top: 1px;

  width: calc(100% - 40px);
}
</style>
